export enum AppFormFieldDTOType {
  UNSPECIFIED_FORM_COMPONENT_TYPE = 0,
  // select from dropdown component
  DROPDOWN_FORM_COMPONENT_TYPE = 1,
  // input to text field component
  TEXT_FIELD_FORM_COMPONENT_TYPE = 2,
  // select from radio button component
  RADIO_BUTTON_FORM_COMPONENT_TYPE = 3,
}
